// extracted by mini-css-extract-plugin
module.exports = {"widget":"TurnstileWidget_widget__sJash"};